import { IconCheck, IconX } from "@tabler/icons-react";


interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
    size?: 'sm' | 'md' | 'lg';
}

export default function CustomCheckbox({
    checked,
    onChange,
    size = 'md',
}: Props) {

    const sizeClassname = {
        sm: 'h-4 w-4',
        md: 'h-5 w-5',
        lg: 'h-6 w-6',
    }[size];

    return (
        <div
            className={`
                rounded-sm border 
                ${sizeClassname}
                flex items-center justify-center
                hover:border-gray-500 
                cursor-pointer
                ${checked ? `border-black` : 'border-gray-200'}
                ${checked ? `bg-black` : 'bg-white'}
            `}
            onClick={() => onChange(!checked)}
        >
            {checked ? <IconCheck size={10} stroke={3} color="white" /> : null}
        </div>
    )
}